import React, { useState, cloneElement, isValidElement } from "react";
import { Box, Menu, MenuItem, useTheme } from "@mui/material";
import { downloadJobFolderAsZip } from "../utils/folderDownload";

const JobFolderDownloadTrigger = ({
  children,
  folderId,
  jobName,
  sx,
  className,
  disabled = false,
}) => {
  const theme = useTheme();
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleContextMenu = event => {
    if (disabled) return;
    event.preventDefault();
    event.stopPropagation();
    setMenuAnchor({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
    });
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleDownload = async () => {
    handleCloseMenu();
    await downloadJobFolderAsZip({ folderId, jobName });
  };

  const childWithContextMenu =
    isValidElement(children) && typeof children.type !== "string"
      ? cloneElement(children, {
          onContextMenu: event => {
            handleContextMenu(event);
            children.props.onContextMenu?.(event);
          },
        })
      : children;

  return (
    <>
      <Box className={className} sx={{ display: "inline-flex", ...sx }}>
        {childWithContextMenu}
      </Box>
      <Menu
        open={menuAnchor !== null}
        onClose={handleCloseMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          menuAnchor !== null
            ? { top: menuAnchor.mouseY, left: menuAnchor.mouseX }
            : undefined
        }
        slotProps={{
          paper: {
            sx: { zIndex: theme.zIndex.modal + 2 },
          },
        }}
      >
        <MenuItem onClick={handleDownload} disabled={!folderId || disabled}>
          Download Folder as ZIP
        </MenuItem>
      </Menu>
    </>
  );
};

export default JobFolderDownloadTrigger;
